import React, { useEffect, useState } from "react";
import {
  Table,
  Input,
  Button,
  Space,
  Select,
  Tag,
  Divider,
  Modal,
  Drawer,
  Typography,
} from "antd";
import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";
import _ from "lodash";
import moment from "moment";
import { LanguageContext } from "../../../context/LanguageContext";
import { ViewNcrDetails } from "../../viewNcrDetails/viewNcrDetails";
import { NCRServiceAction } from "../../../_actions/ncr.service";
import * as XLSX from "xlsx-js-style";

export class NCRTable extends React.Component {
  static contextType = LanguageContext;
  constructor(props) {
    super(props);
    this.state = {
      ncrShow: false,
      pagination: {
        current: 1,
        pageSize: 10,
      },
      masterId: "",
      name: "",
      showData: false,
      data: [],
      loading: false,
    };
  }

  handleOpenNcrDetails = (id) => {
    this.setState(
      { showData: true },
      () => this.ncrList(id) // callback after state update
    );
  };

  handleCloseNcrDetails = () => {
    this.setState({
      showData: false,
    });
  };

  ncrList = (id) => {
    const { startDate, endDate } = this.props;
    let startDate1 = moment(startDate).format("YYYY-MM-DD");
    let endDate1 = moment(endDate).format("YYYY-MM-DD");
    this.setState({
      loading: true,
    });
    let obj = {
      districtId: id,
      startDate: startDate1,
      endDate: endDate1,
    };
    NCRServiceAction.NcrList(obj).then((res) => {
      res &&
        res.text().then((criminalList) => {
          let criminal = JSON.parse(criminalList);
          let list = criminal.results;
          this.setState({
            data: list,
            loading: false,
          });
        });
    });
  };
  handleOpenNcrShow = (id, name) => {
    this.setState({
      ncrShow: true,
      masterId: id,
      name: name,
    });
  };
  handleCloseNcrShow = () => {
    this.setState({
      ncrShow: false,
    });
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.setState({
      pagination: {
        ...this.state.pagination,
        ...pagination, // updates current and pageSize from AntD
      },
    });
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  handleViewForm = (data) => {
    this.props.onViewAccusedForm(data);
  };
  getCityName = (id) => {
    console.log("this.props city", this.props);
    const { pc_cities } = this.props && this.props.professionals;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };
  download_csv = (info) => {
    const { t } = this.context;

    const report_name = info;
    const file_name = `${report_name}_${moment().format("DDMMMYYYY")}`;
    const ReportTitle = info;

    const arrData =
      Array.isArray(this.state.data) &&
      this.state.data.map((data, index) => ({
        [t("sr.no")]: index + 1,
        [t("accused_police_station")]: data?.districtName || "-",
        [t("name")]: data?.name || "-",

        [t("age")]: data?.age || "-",
        [t("total_crimes")]: data.totalCrimeCount,
      }));

    if (!arrData.length) return;
    const ws = XLSX.utils.json_to_sheet(arrData, { origin: "A4" });

    const columnWidths = Object.keys(arrData[0]).map((key) => ({
      wch:
        Math.max(
          key.length,
          ...arrData.map((row) => String(row[key] || "").length)
        ) + 6,
    }));

    ws["!cols"] = columnWidths;

    const titleStyle = {
      font: { bold: true, sz: 16, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const subTitleStyle = {
      font: { bold: true, sz: 12, color: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const headerStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "305496" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    const cellStyle = {
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    Object.keys(arrData[0]).forEach((_, colIndex) => {
      const cellRef = XLSX.utils.encode_cell({ r: 3, c: colIndex });
      if (ws[cellRef]) {
        ws[cellRef].s = headerStyle;
      }
    });

    arrData.forEach((row, rowIndex) => {
      Object.values(row).forEach((_, colIndex) => {
        const cellRef = XLSX.utils.encode_cell({
          r: rowIndex + 4,
          c: colIndex,
        });
        if (ws[cellRef]) {
          ws[cellRef].s = cellStyle;
        }
      });
    });

    console.log("this props.user", this.props.user);
    const cityName = this.getCityName(this.props?.user?.cityId || "");
    console.log("cityName", cityName);
    const stateName =
      this.props?.user?.role === "2" && this.state.district_name;
    const headerData =
      this.props?.user?.role === "2"
        ? `${stateName} (${cityName})`
        : `${cityName}`;

    ws["A1"] = { v: headerData, t: "s" };
    ws["A1"].s = titleStyle;

    ws["A2"] = { v: ReportTitle, t: "s" };
    ws["A2"].s = subTitleStyle;

    ws["A3"] = {
      v: `From: ${
        moment(this.props.startDate).format("DD-MM-YYYY") || "-"
      } To ${moment(this.props.endDate).format("DD-MM-YYYY") || "-"}`,
      t: "s",
    };

    ws["A3"].s = subTitleStyle;

    const footerContent = `Generated At ${moment(new Date()).format(
      "DD MMM YYYY"
    )} From Criminal Monitoring Intelligent System`;

    const footerRowIndex = arrData.length + 6;

    XLSX.utils.sheet_add_aoa(ws, [[footerContent]], {
      origin: `A${footerRowIndex}`,
    });
    ws[`A${footerRowIndex}`].s = {
      font: { italic: true, sz: 11, color: { rgb: "555555" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const mergeRanges = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: columnWidths.length - 1 } },
      { s: { r: 1, c: 0 }, e: { r: 1, c: columnWidths.length - 1 } },
      {
        s: { r: footerRowIndex - 1, c: 0 },
        e: { r: footerRowIndex - 1, c: columnWidths.length - 1 },
      },
      { s: { r: 2, c: 0 }, e: { r: 2, c: columnWidths.length - 1 } },
    ];

    ws["!merges"] = mergeRanges;

    ws["!rows"] = Array(footerRowIndex).fill({ hpt: 25 });
    ws["!rows"][footerRowIndex - 1] = { hpt: 40 };

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");

    XLSX.writeFile(wb, `${file_name}.xlsx`);
  };
  render() {
    let tempColumns = [];
    console.log(this.props.userRole);
    const { pagination, info } = this.state;
    const { language, t } = this.context;
    let tebleData =
      this.props.data &&
      this.props.data.map((item, index) => {
        return {
          ...item,
          srNo: index + 1,
        };
      });
    const columnTotals = tebleData.reduce(
      (acc, row) => {
        acc.count += Number(row.count || 0);

        return acc;
      },
      {
        count: 0,
      }
    );

    const columnHeader = (label, total) => (
      <div style={{ textAlign: "center" }}>
        <div>{label}</div>
        <div style={{ fontSize: 12, color: "rgb(155, 0, 0)", fontWeight: 600 }}>
          (एकूण - {total})
        </div>
      </div>
    );
    let columnsOb =
      this.props.showList === "list"
        ? [
            {
              title: t("sr.no"),
              key: "sr.no",
              render: (text, record) => (
                <Space size="middle" style={{ maxWidth: 300 }}>
                  {record.srNo}
                </Space>
              ),
            },
            {
              title: t("accused_police_station"),
              key: "districtName",
              render: (text, record) => (
                <Space size="middle" style={{ maxWidth: 300 }}>
                  {record.districtName}
                </Space>
              ),
            },
            {
              title: t("name"),
              key: "name",
              render: (text, record) => (
                <Space size="middle" style={{ maxWidth: 300 }}>
                  {record.name}
                </Space>
              ),
            },

            {
              title: t("age"),
              key: "age",
              render: (text, record) => (
                <Space size="middle" style={{ maxWidth: 300 }}>
                  {record.age}
                </Space>
              ),
            },

            {
              title: t("total_crimes"),
              key: "totalCrimeCount",
              render: (text, record) => (
                <div>
                  <Button
                    type="primary"
                    shape="circle"
                    size="small"
                    style={{
                      width: 36,
                      height: 36,
                      fontWeight: 600,
                      boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                    }}
                    onClick={() => {
                      this.handleOpenNcrShow(record.id, record.name);
                    }}
                  >
                    {record.totalCrimeCount}
                  </Button>
                </div>
              ),
            },
            {
              title: t("action"),
              key: "action",
              render: (text, record) => (
                <div style={{ justifyContent: "center" }}>
                  <Button
                    type="text"
                    size="small"
                    onClick={() => {
                      this.handleViewForm(record.id);
                    }}
                    className="action-link update-link"
                  >
                    {t("view1")}
                  </Button>
                </div>
              ),
            },
          ]
        : [
            {
              title: t("sr.no"),
              key: "sr.no",
              render: (text, record) => (
                <Space size="middle" style={{ maxWidth: 300 }}>
                  {record.srNo}
                </Space>
              ),
            },
            {
              title: t("accused_police_station"),
              key: "districtName",
              render: (text, record) => (
                <Space size="middle" style={{ maxWidth: 300 }}>
                  {record.districtName}
                </Space>
              ),
            },
            {
              title: columnHeader(t("count"), columnTotals.count),
              key: "count",
              render: (text, record) => (
                <Button
                  type="primary"
                  shape="circle"
                  size="small"
                  style={{
                    width: 36,
                    height: 36,
                    fontWeight: 600,
                    boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                  }}
                  onClick={() => {
                    this.handleOpenNcrDetails(record.district);
                    this.setState({ info: record });
                  }}
                  disabled={record.count === 0}
                >
                  {record.count}
                </Button>
              ),
            },
          ];

    let tableData2 =
      this.state.data &&
      this.state.data.length > 0 &&
      this.state.data.map((item, index) => {
        return {
          ...item,
          srNo: index + 1,
        };
      });
    const columnTotals1 = this.state.data.reduce(
      (acc, row) => {
        acc.totalCrimeCount += Number(row.totalCrimeCount || 0);

        return acc;
      },
      {
        totalCrimeCount: 0,
      }
    );

    let columnsOb1 = [
      {
        title: t("sr.no"),
        key: "sr.no",
        render: (text, record) => (
          <Space size="middle" style={{ maxWidth: 300 }}>
            {record.srNo}
          </Space>
        ),
      },
      {
        title: t("accused_police_station"),
        key: "districtName",
        render: (text, record) => (
          <Space size="middle" style={{ maxWidth: 300 }}>
            {record.districtName}
          </Space>
        ),
      },
      {
        title: t("name"),
        key: "name",
        render: (text, record) => (
          <Space size="middle" style={{ maxWidth: 300 }}>
            {record.name}
          </Space>
        ),
      },

      {
        title: t("age"),
        key: "age",
        render: (text, record) => (
          <Space size="middle" style={{ maxWidth: 300 }}>
            {record.age}
          </Space>
        ),
      },

      {
        title: columnHeader(t("total_crimes"), columnTotals1.totalCrimeCount),
        key: "totalCrimeCount",
        render: (text, record) => (
          <div>
            <Button
              type="primary"
              shape="circle"
              size="small"
              style={{
                width: 36,
                height: 36,
                fontWeight: 600,
                boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
              }}
              onClick={() => {
                this.handleOpenNcrShow(record.id, record.name);
              }}
            >
              {record.totalCrimeCount}
            </Button>
          </div>
        ),
      },
      {
        title: t("action"),
        key: "action",
        render: (text, record) => (
          <div style={{ justifyContent: "center" }}>
            <Button
              type="text"
              size="small"
              className="action-link update-link"
              onClick={() => {
                this.handleViewForm(record.id);
              }}
            >
              {t("view1")}
            </Button>
          </div>
        ),
      },
    ];

    const boxStyle = {
      padding: "4px 12px",
      background: "#fff",
      borderRadius: "4px",
      border: "1px solid #d9d9d9",
      display: "flex",
      alignItems: "center",
      gap: "8px",
      marginBottom: "10px",
      marginTop: "10px",
    };
    return (
      <>
        <div style={{ marginBottom: "10px" ,padding:"12px"}}>
          <div style={{ display: "inline-flex", gap: "12px" }}>
            <div className="stats-card stats-accused">
              <span className="stats-text">
                {t("total")}: {this.props.total > 0 ? this.props.total : "0"}
              </span>
            </div>
            </div>
        </div>
        <Table
          bordered
          columns={columnsOb}
          dataSource={tebleData}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            showSizeChanger: true,
          }}
          onChange={this.handleTableChange}
          loading={this.props.loading}
          rowClassName={() => "govt-table-row"}
        />
        <Modal
          title=""
          top
          visible={this.state.ncrShow}
          onOk={this.handleCloseNcrShow}
          onCancel={this.handleCloseNcrShow}
          width={95 + "%"}
        >
          <ViewNcrDetails
            masterId={this.state.masterId}
            name={this.state.name}
          />
        </Modal>
        <Drawer
          title={
            <div
              style={{
                position: "relative",
                height: 28,
                display: "flex",
                alignItems: "center",
              }}
            >
              <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                अदखलपात्र गुन्हा यादी
              </span>

              <Typography.Text
                strong
                style={{
                  position: "absolute",
                  left: "50%",
                  transform: "translateX(-50%)",
                  color: "#1d39c4",
                  fontSize: 16,
                  whiteSpace: "nowrap",
                }}
              >
                {t("police_station")} : {info?.districtName}
              </Typography.Text>
            </div>
          }
          placement="right"
          width={900}
          closable={false}
          onClose={this.handleCloseNcrDetails}
          visible={this.state.showData}
          footer={
            <div
              style={{
                textAlign: "left",
              }}
            >
              <Button
                danger
                onClick={this.handleCloseNcrDetails}
                style={{ marginRight: 8 }}
              >
                Cancel
              </Button>
            </div>
          }
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 4,
            }}
          >
            {/* LEFT SIDE DATE */}
            <span>
              {moment(this.props.startDate).format("DD-MM-YYYY")}
              {" To "}
              {moment(this.props.endDate).format("DD-MM-YYYY")}
            </span>

            {/* RIGHT SIDE BUTTON */}
            <Button
              type="primary"
              size="small"
              onClick={() => {
                this.download_csv("अदखलपात्र गुन्हा यादी");
              }}
            >
              Download Excel
            </Button>
          </div>
          <Table
            bordered
            columns={columnsOb1}
            dataSource={tableData2}
            pagination={{
              current: pagination.current,
              pageSize: pagination.pageSize,
              showSizeChanger: true,
            }}
            onChange={this.handleTableChange}
            loading={this.state.loading}
            rowClassName={() => "govt-table-row"}
          />
        </Drawer>
      </>
    );
  }
}
